var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex items-center"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex-none"},[_c('numeral-stepper-new',{model:{value:(_vm.rooms),callback:function ($$v) {_vm.rooms=$$v},expression:"rooms"}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 pr-4",staticStyle:{"min-width":"100px"}},[_c('p',[_vm._v("Rooms")])])
}]

export { render, staticRenderFns }